import React, { useState } from 'react';
import { ConsentJourneyDemo } from './components/ConsentJourneyDemo';
import { AppLayout } from './components/layouts/AppLayout';
import { PFMAfterScreen } from './components/screens/PFMAfterScreen';
import { AccountsScreen } from './components/screens/AccountsScreen';
import { InsightsScreen } from './components/screens/InsightsScreen';
import { SettingsScreen } from './components/screens/SettingsScreen';
import { ConsentManagementScreen } from './components/screens/ConsentManagementScreen';
import { MOCK_DATA } from './constants/mockData';
type AppView = 'landing' | 'consent-flow' | 'app';
type AppTab = 'home' | 'accounts' | 'insights' | 'settings' | 'consent-management';
export function App() {
  const [currentView, setCurrentView] = useState<AppView>('landing');
  const [activeTab, setActiveTab] = useState<AppTab>('home');
  const [activeConsents, setActiveConsents] = useState(MOCK_DATA.active);
  const [pendingConsents, setPendingConsents] = useState(MOCK_DATA.pending);
  const [historyConsents, setHistoryConsents] = useState(MOCK_DATA.history);
  // Connected banks from active consents
  const connectedBanks = Array.from(new Set(activeConsents.map(c => ({
    name: c.bankName,
    logoUrl: c.bankLogo
  }))));
  // Mock accounts data for AccountsScreen
  const mockAccounts = [{
    id: '1',
    bankName: 'Abu Dhabi Commercial Bank',
    bankLogo: 'https://cdn.magicpatterns.com/uploads/wpkTMSY3dU4JPGR41Jm2TG/ADCB_icon.svg',
    accountType: 'Current Account',
    accountNumber: '4627033234562456',
    balance: 15230,
    currency: 'AED'
  }, {
    id: '2',
    bankName: 'Abu Dhabi Commercial Bank',
    bankLogo: 'https://cdn.magicpatterns.com/uploads/vx9U521haxff7iDHoRnSwB/ADCB_black_logo_(3).svg',
    accountType: 'Savings Account',
    accountNumber: '7890123456789012',
    balance: 12500,
    currency: 'AED'
  }, {
    id: '3',
    bankName: 'ADIB',
    bankLogo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tNEFVG5j2DGJtEABNU4nN9/ADIB.jpg',
    accountType: 'Savings Account',
    accountNumber: '6666555544443333',
    balance: 4720,
    currency: 'AED'
  }];
  const handleConsentFlowComplete = () => {
    setCurrentView('app');
    setActiveTab('home');
  };
  const handleStartConsentFlow = () => {
    setCurrentView('consent-flow');
  };
  const handleSkipToApp = () => {
    setCurrentView('app');
    setActiveTab('home');
  };
  const handleAddAccount = () => {
    setCurrentView('consent-flow');
  };
  const handleManageConsents = () => {
    setActiveTab('consent-management');
  };
  const handleTabChange = (tabId: string) => {
    setActiveTab(tabId as AppTab);
  };
  const handleRevokeConsent = (consentId: string) => {
    const consent = activeConsents.find(c => c.id === consentId);
    if (consent) {
      const revokedConsent = {
        ...consent,
        state: 'Canceled' as const,
        canceledDate: new Date().toLocaleDateString('en-GB')
      };
      setActiveConsents(activeConsents.filter(c => c.id !== consentId));
      setHistoryConsents([...historyConsents, revokedConsent]);
    }
  };
  const handlePayBill = (billId: string) => {
    console.log('Pay bill:', billId);
    // In a real app, this would initiate a one-time payment
    alert(`Payment flow for bill ${billId} would start here`);
  };
  const handleSetupAutoPay = (billId: string) => {
    console.log('Setup auto-pay for bill:', billId);
    // In a real app, this would start the VRP setup flow
    alert(`VRP setup for bill ${billId} would start here. In the full demo (ConsentJourneyDemo), this opens the VRP flow.`);
  };
  // Show landing/consent flow (existing ConsentJourneyDemo)
  if (currentView === 'landing' || currentView === 'consent-flow') {
    return <div className="w-full min-h-screen" data-id="element-0">
        <ConsentJourneyDemo onComplete={handleConsentFlowComplete} onStartFlow={handleStartConsentFlow} onSkipToApp={handleSkipToApp} data-id="element-1" />
      </div>;
  }
  // Show app with navigation
  return <AppLayout activeTab={activeTab} onTabChange={handleTabChange} pageTitle={activeTab === 'home' ? 'Dashboard' : activeTab === 'accounts' ? 'Accounts' : activeTab === 'insights' ? 'Insights' : activeTab === 'settings' ? 'Settings' : 'Manage Consents'} notificationCount={3} consentBadgeCount={pendingConsents.length} data-id="element-2">
      {activeTab === 'home' && <PFMAfterScreen connectedBanks={connectedBanks} onAddMoreAccounts={handleAddAccount} onManageConsents={handleManageConsents} onPayBill={handlePayBill} onSetupAutoPay={handleSetupAutoPay} data-id="element-3" />}

      {activeTab === 'accounts' && <AccountsScreen accounts={mockAccounts} onAddAccount={handleAddAccount} onViewAccount={id => console.log('View account:', id)} data-id="element-4" />}

      {activeTab === 'insights' && <InsightsScreen data-id="element-5" />}

      {activeTab === 'settings' && <SettingsScreen onManageConsents={handleManageConsents} pendingConsentsCount={pendingConsents.length} data-id="element-6" />}

      {activeTab === 'consent-management' && <ConsentManagementScreen activeConsents={activeConsents} historyConsents={historyConsents} onViewDetails={id => console.log('View details:', id)} onUpdateConsent={id => console.log('Update:', id)} onRevokeConsent={handleRevokeConsent} onAddNewConnection={handleAddAccount} data-id="element-7" />}
    </AppLayout>;
}